import type { PropsWithChildren } from "react";
import { BaseLayoutV2Adjustable } from "./BaseLayoutV2Adjustable";

interface ISignaturePageLayoutProps {
  readonly header: React.ReactNode;
}

export function SignaturePageLayout({ children, header }: PropsWithChildren<ISignaturePageLayoutProps>): JSX.Element {
  return <BaseLayoutV2Adjustable header={header}>{children}</BaseLayoutV2Adjustable>;
}
